// extracted by mini-css-extract-plugin
export default {"p__container":"Mailing_p__container__Ede4e","p__Info":"Mailing_p__Info__exRZx"};